var Backbone, FAQContentModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

FAQContentModel = (function(superClass) {
  extend(FAQContentModel, superClass);

  function FAQContentModel() {
    return FAQContentModel.__super__.constructor.apply(this, arguments);
  }

  FAQContentModel.prototype.initialize = function() {
    this.baseUrl = window.FAQBASEURL + "/topics";
    this.container = $('#content-container');
    this.spinner = $('.g-spinner');
    return this.errorContainer = $('#error-container');
  };

  FAQContentModel.prototype.setUrl = function(queryParams) {
    var articleId, topicId;
    switch (queryParams != null ? queryParams.category : void 0) {
      case "topic":
        topicId = encodeURIComponent(queryParams.topicId);
        return this.url = this.baseUrl + "/" + topicId + "/articles?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
      case "article":
        topicId = encodeURIComponent(queryParams.topicId);
        articleId = encodeURIComponent(queryParams.articleId);
        return this.url = this.baseUrl + "/" + topicId + "/articles/" + articleId + "?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
    }
  };

  FAQContentModel.prototype.fetchContent = function(queryParams, sucessCallback, errorCallback) {
    this.setUrl(queryParams);
    this.container.empty();
    this.errorContainer.empty();
    this.spinner.show();
    this.fetch({
      success: (function(_this) {
        return function(model, response, options) {
          stopTimer("t_fs");
          _this.spinner.hide();
          return sucessCallback(response);
        };
      })(this),
      error: (function(_this) {
        return function(model, xhr, options) {
          stopTimer("t_fs");
          _this.spinner.hide();
          return errorCallback(queryParams);
        };
      })(this)
    });
    return startTimer("t_fs");
  };

  return FAQContentModel;

})(Backbone.Model);

module.exports = FAQContentModel;

//# sourceMappingURL=data:application/json;base64,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
